let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("gw9ua")).then(() => parcelRequire('8DuT4'));